import { createSlice } from "@reduxjs/toolkit";
import dynamicFieldsApi from "./dynamicFieldsApi";

const initialState = {
    loading: false,
    entities: undefined,
    currentRequestId: undefined,
    error: undefined,
};

const dynamicFields = createSlice({
    name: "dynamicFields",
    initialState,
    reducers: {
        resetDynamicFileds() {
            return initialState;
        },
    },
    extraReducers: {
        [dynamicFieldsApi.pending]: (state, action) => {
            const newState = state;
            const { requestId } = action.meta;

            if (state.loading === false && !state.currentRequestId) {
                newState.loading = true;
                newState.currentRequestId = requestId;
            }
        },
        [dynamicFieldsApi.fulfilled]: (state, action) => {
            const newState = state;
            const { requestId } = action.meta;

            if (state.loading === true && state.currentRequestId === requestId) {
                newState.loading = false;
                newState.entities = action.payload;
                newState.currentRequestId = undefined;
            }
        },
        [dynamicFieldsApi.rejected]: (state, action) => {
            const newState = state;
            const { requestId } = action.meta;

            if (state.loading === true && state.currentRequestId === requestId) {
                newState.loading = false;
                newState.error = action.payload?.error;
                newState.currentRequestId = undefined;
            }
        },
    },
});

const { resetDynamicFileds } = dynamicFields.actions;
const dynamicFieldsReducer = dynamicFields.reducer;

export { dynamicFieldsReducer, resetDynamicFileds, dynamicFieldsApi };
